import { useSyncExternalStore } from "react";
import en from "./locales/en.json";
import am from "./locales/am.json";
import om from "./locales/om.json";
import so from "./locales/so.json";
import ti from "./locales/ti.json";

/** Same languages, order and native names as the ODOS Merchant app. */
export const LANGUAGES = [
  { code: "en", nativeName: "English" },
  { code: "am", nativeName: "አማርኛ" },
  { code: "om", nativeName: "Afaan Oromoo" },
  { code: "ti", nativeName: "ትግርኛ" },
  { code: "so", nativeName: "Af-Soomaali" },
];

const DICTIONARIES = { en, am, om, so, ti };
const STORAGE_KEY = "odos.merchant.language";
const listeners = new Set();

function readStoredLanguage() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v && DICTIONARIES[v] ? v : "en";
  } catch (_) {
    return "en";
  }
}

let current = readStoredLanguage();
if (typeof document !== "undefined") document.documentElement.lang = current;

export function getLanguage() {
  return current;
}

/** Switches the UI language for this browser (remembered) and re-renders the app. */
export function setLanguage(code) {
  if (!DICTIONARIES[code] || code === current) return;
  current = code;
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch (_) {
    /* private mode: the choice lasts for this tab only */
  }
  document.documentElement.lang = code;
  listeners.forEach((l) => l());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Current language; components using it re-render when it changes. */
export function useLanguage() {
  return useSyncExternalStore(subscribe, getLanguage);
}

/**
 * Translates `key` into the current language, falling back to English, then to the key itself.
 * `{name}` placeholders are filled from `params`.
 */
export function t(key, params) {
  let text = DICTIONARIES[current][key] ?? DICTIONARIES.en[key] ?? key;
  if (params) {
    for (const [name, value] of Object.entries(params)) {
      text = text.split(`{${name}}`).join(String(value ?? ""));
    }
  }
  return text;
}
